export enum IMAGES {
  PLACEHOLDER = "/products/placeholder-product.png",
}
